import React from "react";

const Table = ({ data, columns, onClick }) => {
  return (
    <table className="table text-light no-border-table table-striped my-table">
      <colgroup>
        {columns?.map(({ colWidth }, idx) => (
          <col key={idx} style={{ width: colWidth || "auto" }} />
        ))}
      </colgroup>
      <thead>
        <tr>
          {columns?.map(({ label }, idx) => (
            <th key={idx}>{label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data?.map((row, ridx) => (
          <tr key={ridx} onClick={() => onClick && onClick(row)}>
            {columns?.map(({ field, rowValue }, cidx) => (
              <td key={cidx}>
                {rowValue ? rowValue(row[field], row) : row[field]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
